import React, { createContext, useState } from 'react';

export const RxNowUnreadContext = createContext({
    unreadCount: 0,
    setUnreadCount: () => {},
    hasNewMessage: false,
    setHasNewMessage: () => {}
});

export const RxNowUnreadProvider = ({ children }) => {
    const [unreadCount, setUnreadCount] = useState(0);
    const [hasNewMessage, setHasNewMessage] = useState(false);

    return (
        <RxNowUnreadContext.Provider value={{ unreadCount, setUnreadCount, hasNewMessage, setHasNewMessage }}>
            {children}
        </RxNowUnreadContext.Provider>
    );
};
